import localeSeoCorrections from "./localeSeoCorrections.json";
import cmsSiteContent from "../shared/cmsSiteContent.cjs";

const { applyCmsContentOverrides } = cmsSiteContent;

const RUNTIME_LOCALE_LOADERS = {
  af: () => import("./runtimeLocales/af.json"),
  ar: () => import("./runtimeLocales/ar.json"),
  bn: () => import("./runtimeLocales/bn.json"),
  zh: () => import("./runtimeLocales/zh.json"),
  "zh-TW": () => import("./runtimeLocales/zh-TW.json"),
  tl: () => import("./runtimeLocales/tl.json"),
  en: () => import("./runtimeLocales/en.json"),
  fr: () => import("./runtimeLocales/fr.json"),
  de: () => import("./runtimeLocales/de.json"),
  ha: () => import("./runtimeLocales/ha.json"),
  hi: () => import("./runtimeLocales/hi.json"),
  id: () => import("./runtimeLocales/id.json"),
  it: () => import("./runtimeLocales/it.json"),
  ja: () => import("./runtimeLocales/ja.json"),
  km: () => import("./runtimeLocales/km.json"),
  ko: () => import("./runtimeLocales/ko.json"),
  lo: () => import("./runtimeLocales/lo.json"),
  ms: () => import("./runtimeLocales/ms.json"),
  mm: () => import("./runtimeLocales/mm.json"),
  pt: () => import("./runtimeLocales/pt.json"),
  ru: () => import("./runtimeLocales/ru.json"),
  es: () => import("./runtimeLocales/es.json"),
  sw: () => import("./runtimeLocales/sw.json"),
  th: () => import("./runtimeLocales/th.json"),
  tr: () => import("./runtimeLocales/tr.json"),
  ur: () => import("./runtimeLocales/ur.json"),
  vi: () => import("./runtimeLocales/vi.json")
};

export const PRODUCT_ROUTES = [
  {
    key: "url",
    path: "/products/url-qr",
    icon: "globe",
    faIcon: "fa-link",
    generatorTab: "url",
    mode: "dynamic",
    supportedLanguages: ["en", "vi", "ja", "th", "zh-TW", "ko", "id", "ms", "fr"]
  },
  { key: "dynamic", path: "/products/dynamic-qr", icon: "dynamic", faIcon: "fa-line-chart" },
  { key: "static", path: "/products/static-qr", icon: "static", faIcon: "fa-qrcode" },
  { key: "customize", path: "/products/custom-qr-code", icon: "palette", faIcon: "fa-paint-brush", generatorTab: "url", mode: "static", openCustomizer: true },
  { key: "pdf", path: "/products/pdf-qr", icon: "pdf", faIcon: "fa-file-pdf-o" },
  { key: "cloudLinks", path: "/products/cloud-drive-forms-qr", icon: "cloudLinks", faIcon: "fa-cloud", generatorTab: "url", mode: "static" },
  { key: "maps", path: "/products/google-maps-qr", icon: "location", faIcon: "fa-map-marker", generatorTab: "url", mode: "static", urlPlaceholder: "https://maps.app.goo.gl/your-location-link" },
  { key: "payment", path: "/products/payment-qr", icon: "payment", faIcon: "fa-credit-card", generatorTab: "payment", paymentNetwork: "vietqr", mode: "static" },
  { key: "vcard", path: "/products/vcard-qr", icon: "ninecard", faIcon: "fa-address-card-o", generatorTab: "vcard", mode: "static" },
  { key: "text", path: "/products/text-qr", icon: "text", faIcon: "fa-font", generatorTab: "text", mode: "static" },
  { key: "email", path: "/products/email-qr", icon: "mail", faIcon: "fa-envelope-o", generatorTab: "email", mode: "static" },
  { key: "social", path: "/products/social-media-qr", icon: "globe", faIcon: "fa-share-alt", generatorTab: "facebook", mode: "static", socialPlatform: "facebook" },
  { key: "wifi", path: "/products/wifi-qr", icon: "wifi", faIcon: "fa-wifi", generatorTab: "wifi", mode: "static" },
  { key: "phone", path: "/products/phone-qr", icon: "mobile", faIcon: "fa-phone", generatorTab: "phone", mode: "static" },
  { key: "sms", path: "/products/sms-qr", icon: "message", faIcon: "fa-commenting-o", generatorTab: "sms", mode: "static" },
  { key: "link", path: "/products/short-link", icon: "link", faIcon: "fa-link" },
  { key: "ninecheck", path: "/products/ninecheck", icon: "ninecheck", faIcon: "fa-check-square-o" },
  { key: "ninecard", path: "/products/ninecard", icon: "ninecard", faIcon: "fa-address-card-o" },
  { key: "menu", path: "/products/nine-menu", icon: "menu", faIcon: "fa-cutlery" }
];

export const SOCIAL_PRODUCT_ROUTES = [
  { key: "socialFacebook", path: "/products/social-media/facebook-qr", icon: "globe", generatorTab: "facebook", mode: "static", socialPlatform: "facebook", group: "social" },
  { key: "socialInstagram", path: "/products/social-media/instagram-qr", icon: "image", generatorTab: "facebook", mode: "static", socialPlatform: "instagram", group: "social" },
  { key: "socialWhatsapp", path: "/products/social-media/whatsapp-qr", icon: "message", generatorTab: "facebook", mode: "static", socialPlatform: "whatsapp", group: "social" },
  { key: "socialLine", path: "/products/social-media/line-qr", icon: "message", generatorTab: "facebook", mode: "static", socialPlatform: "line", group: "social" },
  { key: "socialLinkedin", path: "/products/social-media/linkedin-qr", icon: "briefcase", generatorTab: "facebook", mode: "static", socialPlatform: "linkedin", group: "social" },
  { key: "socialYoutube", path: "/products/social-media/youtube-qr", icon: "mobile", generatorTab: "facebook", mode: "static", socialPlatform: "youtube", group: "social" },
  { key: "socialTiktok", path: "/products/social-media/tiktok-qr", icon: "music", generatorTab: "facebook", mode: "static", socialPlatform: "tiktok", group: "social" },
  { key: "socialX", path: "/products/social-media/x-qr", icon: "message", generatorTab: "facebook", mode: "static", socialPlatform: "x", group: "social" },
  { key: "socialTelegram", path: "/products/social-media/telegram-qr", icon: "send", generatorTab: "facebook", mode: "static", socialPlatform: "telegram", group: "social" }
];

export const PAYMENT_PRODUCT_ROUTES = [
  { key: "vietqr", path: "/products/vietqr", icon: "payment", generatorTab: "payment", paymentNetwork: "vietqr", mode: "static", group: "payment" },
  { key: "promptpay", path: "/products/promptpay-qr", icon: "payment", generatorTab: "payment", paymentNetwork: "promptpay", mode: "static", group: "payment" },
  { key: "pix", path: "/products/pix-qr", icon: "payment", generatorTab: "payment", paymentNetwork: "pix", mode: "static", group: "payment" },
  { key: "upi", path: "/products/upi-qr", icon: "payment", generatorTab: "payment", paymentNetwork: "upi", mode: "static", group: "payment" },
  { key: "epc", path: "/products/epc-qr", icon: "payment", generatorTab: "payment", paymentNetwork: "epc", mode: "static", group: "payment" },
  { key: "paynow", path: "/products/paynow-qr", icon: "payment", generatorTab: "payment", paymentNetwork: "paynow", mode: "static", group: "payment" },
  { key: "swissqr", path: "/products/swiss-qr-bill", icon: "payment", generatorTab: "payment", paymentNetwork: "swissqr", mode: "static", group: "payment" },
  { key: "spayd", path: "/products/spayd-qr", icon: "payment", generatorTab: "payment", paymentNetwork: "spayd", mode: "static", group: "payment" },
  { key: "paybysquare", path: "/products/pay-by-square-qr", icon: "payment", generatorTab: "payment", paymentNetwork: "paybysquare", mode: "static", group: "payment" },
  { key: "hub3", path: "/products/hub3-barcode", icon: "payment", generatorTab: "payment", paymentNetwork: "hub3", mode: "static", group: "payment" },
  { key: "ips", path: "/products/ips-qr", icon: "payment", generatorTab: "payment", paymentNetwork: "ips", mode: "static", group: "payment" },
  { key: "upn", path: "/products/upn-qr", icon: "payment", generatorTab: "payment", paymentNetwork: "upn", mode: "static", group: "payment" }
];

export const ALL_PRODUCT_ROUTES = [
  ...PRODUCT_ROUTES,
  ...SOCIAL_PRODUCT_ROUTES,
  ...PAYMENT_PRODUCT_ROUTES
];

export const normalizeRedesignLanguage = (language) => {
  const raw = String(language || "en").trim().replace(/_/g, "-");
  if (!raw) return "en";
  if (raw.toLowerCase() === "zh-tw") return "zh-TW";
  if (raw.toLowerCase() === "vn") return "vi";
  if (raw.toLowerCase() === "my") return "mm";
  if (raw.toLowerCase() === "fil") return "tl";
  return raw.toLowerCase().split("-")[0];
};

const toPlaceholderToken = (key) =>
  `%${key
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/([a-zA-Z])(\d)/g, "$1_$2")
    .replace(/(\d)([a-zA-Z])/g, "$1_$2")
    .toUpperCase()}%`;

const replacePlaceholders = (value, replacements) => {
  if (typeof value === "string") {
    return Object.entries(replacements).reduce(
      (result, [token, replacement]) =>
        result.split(token).join(String(replacement || "")),
      value
    );
  }
  if (Array.isArray(value)) {
    return value.map((entry) => replacePlaceholders(entry, replacements));
  }
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [
        key,
        replacePlaceholders(entry, replacements)
      ])
    );
  }
  return value;
};

const materializeSocialPages = (productContent) =>
  SOCIAL_PRODUCT_ROUTES.reduce((pages, route) => {
    const platform = productContent.socialPlatforms?.[route.key];
    if (!platform) return pages;
    const replacements = Object.fromEntries(
      Object.entries(platform).map(([key, value]) => [
        toPlaceholderToken(key),
        value
      ])
    );
    pages[route.key] = replacePlaceholders(
      productContent.socialTemplate,
      replacements
    );
    return pages;
  }, {});

const materializePaymentPages = (productContent) =>
  PAYMENT_PRODUCT_ROUTES.reduce((pages, route) => {
    if (productContent.pages?.[route.key]) return pages;
    const standard = productContent.paymentStandards?.[route.key];
    if (!standard) return pages;
    const name = standard.name;
    const template = productContent.paymentTemplate;
    const withName = (value) =>
      replacePlaceholders(value, { "%NAME%": name });
    pages[route.key] = {
      navLabel: standard.navLabel,
      seoTitle: standard.seoTitle,
      title: standard.title,
      description: standard.description,
      primary: standard.primary,
      facts: standard.facts,
      demoTitle: withName(template.demoTitle),
      demoLabels: template.demoLabels,
      whyTitle: withName(template.whyTitle),
      whyDescription: standard.whyDescription,
      benefits: standard.benefits,
      technicalGuide: {
        title: withName(template.technicalTitle),
        description: standard.technicalDescription,
        points: standard.technicalPoints,
        example: standard.example,
        troubleshooting: standard.troubleshooting
      },
      creationGuide: {
        title: withName(template.creationTitle),
        description: standard.creationDescription,
        tips: standard.creationTips
      },
      pros: standard.pros,
      cons: standard.cons,
      steps: standard.steps,
      useCases: standard.useCases,
      faqs: standard.faqs,
      howItWorksEyebrow: withName(template.howEyebrow),
      howItWorksTitle: withName(template.howTitle),
      ctaTitle: withName(template.ctaTitle),
      ctaDescription: standard.ctaDescription
    };
    return pages;
  }, {});

const applyProductCommon = (page, common) => ({
  eyebrow: common.eyebrow,
  facts: common.facts,
  demoStatus: common.demoStatus,
  features: common.features,
  ...page
});

const PAYMENT_PRODUCT_KEYS = new Set([
  "payment",
  ...PAYMENT_PRODUCT_ROUTES.map((route) => route.key)
]);

const localizedContentCache = new Map();
const runtimeLocaleSources = new Map();

const applyLocaleSeoCorrections = (value, replacements) => {
  if (!replacements || Object.keys(replacements).length === 0) return value;
  if (typeof value === "string") return replacements[value] || value;
  if (Array.isArray(value)) {
    return value.map((entry) =>
      applyLocaleSeoCorrections(entry, replacements)
    );
  }
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [
        key,
        applyLocaleSeoCorrections(entry, replacements)
      ])
    );
  }
  return value;
};

// `cms`: override từ Content Hub (object partial cùng hình content, đã gom theo ngôn ngữ) —
// áp SAU CÙNG để admin sửa gì thấy đúng cái đó (sau editorial/corrections/materialize).
export const buildRedesignContent = ({
  base: sourceBase,
  qrProducts: sourceQrProducts,
  corrections = {},
  cms = null
}) => {
  const base = applyLocaleSeoCorrections(
    sourceBase,
    corrections
  );
  const qrProducts = applyLocaleSeoCorrections(
    sourceQrProducts,
    corrections
  );
  const basePages = Object.fromEntries(
    Object.entries(base.pages || {}).map(([key, page]) => [
      key,
      replacePlaceholders(page, { "%BRAND%": "QRCode GEN" })
    ])
  );
  const newPages = {
    ...qrProducts.pages,
    ...materializeSocialPages(qrProducts),
    ...materializePaymentPages(qrProducts)
  };
  const normalizedNewPages = Object.fromEntries(
    Object.entries(newPages).map(([key, page]) => {
      const normalizedPage = applyProductCommon(
        replacePlaceholders(page, { "%BRAND%": "QRCode GEN" }),
        qrProducts.common
      );
      return [
        key,
        PAYMENT_PRODUCT_KEYS.has(key) && qrProducts.paymentTemplate?.features
          ? { ...normalizedPage, features: qrProducts.paymentTemplate.features }
          : normalizedPage
      ];
    })
  );
  const content = {
    ...base,
    pages: {
      ...basePages,
      ...normalizedNewPages
    },
    qrProductCommon: qrProducts.common
  };
  return applyCmsContentOverrides(content, cms);
};

export const loadRedesignContent = async (language) => {
  const normalized = normalizeRedesignLanguage(language);
  if (localizedContentCache.has(normalized)) {
    return localizedContentCache.get(normalized);
  }

  const loader = RUNTIME_LOCALE_LOADERS[normalized] || RUNTIME_LOCALE_LOADERS.en;
  const loadedModule = await loader();
  const sources = loadedModule?.default || loadedModule;
  runtimeLocaleSources.set(normalized, sources);

  const content = buildRedesignContent({
    base: sources.base,
    qrProducts: sources.qrProducts,
    corrections: localeSeoCorrections[normalized] || {},
    cms: sources.cms || null
  });
  localizedContentCache.set(normalized, content);
  return content;
};

export const getRedesignContent = (language) => {
  const normalized = normalizeRedesignLanguage(language);
  const cached = localizedContentCache.get(normalized);
  if (cached) return cached;

  const sources = runtimeLocaleSources.get(normalized);
  if (sources) {
    const content = buildRedesignContent({
      base: sources.base,
      qrProducts: sources.qrProducts,
      corrections: localeSeoCorrections[normalized] || {},
      cms: sources.cms || null
    });
    localizedContentCache.set(normalized, content);
    return content;
  }

  throw new Error(
    `Redesign content for "${normalized}" must be loaded before rendering.`
  );
};

export const isRtlLanguage = (language) =>
  ["ar", "ur"].includes(normalizeRedesignLanguage(language));

export const getProductRoute = (productKey) =>
  ALL_PRODUCT_ROUTES.find((route) => route.key === productKey);
